module.exports = __webpack_public_path__ + "static/media/handschuhe_richtig.049b392e.jpg";